export interface Path {
  pathname: string;
  search?: string;
}

export type PathSearchInit =
  | string
  | Record<string, string | undefined | null | number>;

export const joinPath = (left: Path, right: string): Path => ({
  ...left,
  pathname: left.pathname + "/" + right,
});

export const intoSearchParams = (
  init: PathSearchInit | undefined,
): URLSearchParams => {
  if (typeof init === "undefined") {
    return new URLSearchParams();
  }
  if (typeof init === "string") {
    return new URLSearchParams(init);
  }
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(init)) {
    if (typeof value === "string") {
      params.set(key, value);
    } else if (typeof value === "number") {
      params.set(key, value.toString(10));
    }
  }
  return params;
};

export const intoPath = (pathname: string, search?: PathSearchInit): Path => ({
  pathname,
  search: search ? intoSearchParams(search).toString() : undefined,
});

export const withPathSearch = (
  path: Path,
  searchInit?: PathSearchInit,
): Path => {
  const newSearch = intoSearchParams(searchInit);
  const search = intoSearchParams(path.search);
  for (const [k, v] of newSearch.entries()) {
    search.set(k, v);
  }
  return { ...path, search: newSearch.toString() };
};
